import { render, staticRenderFns } from "./FormIndumentaria.vue?vue&type=template&id=0b9902e8"
import script from "./FormIndumentaria.vue?vue&type=script&setup=true&lang=js"
export * from "./FormIndumentaria.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports